import loadable from '@loadable/component';

import LoadingPage from '../../components/LoadingPage';

const LoadableDocumentsPage = loadable(() => import('./index'), {
  fallback: LoadingPage,
});

export default LoadableDocumentsPage;
